import Component from './component.vue';

export * from './types';

export default Component;



// WEBPACK FOOTER //
// ./src/components/intalent/test/index.ts